<div *ngIf="!isValid && partnershipsLoaded" class="custom-error left-margin">Please select a new primary contact for all listed partnerships</div>
<form [formGroup]="changePrimaryContactForm">
    <p-table [value]="partnerRelationship" 
        autoLayout=true 
        [loading]="loading"
        *ngIf="!failedToLoad">
        <ng-template pTemplate="header">                                                                                                                                    
            <tr>
                <th>Partnership</th>
                <th>New Primary Contact</th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-relationship>
            <tr>
                <td>{{relationship.ParentCompany.Name}} - {{relationship.ChildCompany.Name}}</td>
                <td>
                <p-dropdown [options]="relationship.PartnerUser" 
                    placeholder="Contact Name"
                    optionLabel="Person.FullName"
                    dataKey="Person.PersonId"
                    (onChange)="assignPrimaryContact(relationship.RelationshipId, $event.value)"
                    styleClass="contact-min-width"
                    formControlName="PrimaryContact">
                </p-dropdown>
            </tr>
        </ng-template>
    </p-table>
    <div *ngIf="failedToLoad">Failed to load partnerships and primary contacts.</div>
</form>
